import * as React from 'react'

function SvgGn(props) {
	return (
		<svg viewBox="0 0 3 2" width="1em" height="1em" {...props}>
			<path fill="#ce1126" d="M0 0h1v2H0z" />
			<path fill="#fcd116" d="M1 0h1v2H1z" />
			<path fill="#009460" d="M2 0h1v2H2z" />
		</svg>
	)
}

export default SvgGn
